var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRootTest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#007AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 9.31447C13.2334 9.31887 11.5402 10.0227 10.2909 11.272C9.04165 12.5213 8.33786 14.2144 8.33346 15.9811C8.32308 16.8577 8.49194 17.7271 8.82967 18.536C9.16741 19.3449 9.66689 20.0763 10.2975 20.6852L11.2308 19.7518C10.7327 19.259 10.3389 18.6711 10.0726 18.0229C9.80633 17.3748 9.67308 16.6798 9.68079 15.9791C9.67867 14.5694 10.2366 13.2165 11.2319 12.2181C12.2272 11.2196 13.5783 10.6574 14.9881 10.6551H15.0001C16.4099 10.6534 17.7626 11.2117 18.7608 12.2072C19.759 13.2028 20.3208 14.554 20.3228 15.9638V15.9785C20.3054 17.3876 19.751 18.7369 18.7728 19.7512L19.7028 20.6845C20.6383 19.7552 21.2764 18.5687 21.5362 17.2759C21.7959 15.983 21.6655 14.6422 21.1615 13.4236C20.6575 12.2051 19.8027 11.1639 18.7056 10.4322C17.6086 9.70055 16.3188 9.3115 15.0001 9.31447ZM13.6561 16.1365L14.7935 17.3252L18.1015 13.5525L17.4288 12.8291L13.6561 16.1365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootTest);
export default __webpack_public_path__ + "static/media/Root Test.62e99c47b5fff3000abadff0ed2cb71e.svg";
export { ForwardRef as ReactComponent };